/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IGetBillingStatusRequest, TGetBillingStatusModel, IMappers, TGetBillingStatusResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IV1GetBillingStatusResponseSchema } from '../../entities/response/V1GetBillingStatusResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetBillingStatusModel(parameters: IGetBillingStatusRequest): TGetBillingStatusModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'legal-check',
    pathApi: '/v1/get-billing-status/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetBillingStatusOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetBillingStatusRequest;
}

export async function fetchGetBillingStatus<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetBillingStatusOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetBillingStatusResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetBillingStatusModel(parameters),
    config,
  )) as FetchResponse<TGetBillingStatusResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IV1GetBillingStatusResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetBillingStatusResponse>;
}
